import axios from "../plugins/parseAxios";

export class AccountingChartAPI {
  static getAccountingCharts(projectId) {
    return axios.post("functions/getAccountingCharts", {
      projectId
    });
  }
  static createAccountingChart(formData) {
    return axios.post("functions/createAccountingChart", formData);
  }
  static updateAccountingChart(formData) {
    return axios.post("functions/updateAccountingChart", formData);
  }
}